import styled, { css } from 'styled-components';
import { uiTokens } from './tokens';

type CardTone = 'default' | 'elevated' | 'subtle';
type CardPadding = 'sm' | 'md' | 'lg';
type CardRadius = 'sm' | 'md' | 'lg' | 'pill';

const paddingMap: Record<CardPadding, string> = {
  sm: '0.75rem',
  md: '1.25rem',
  lg: '1.5rem',
};

interface CardProps {
  tone?: CardTone;
  padding?: CardPadding;
  radius?: CardRadius;
  blur?: boolean;
  shadow?: boolean;
}

export const Card = styled.div<CardProps>`
  background: ${({ tone = 'default' }) => {
    if (tone === 'elevated') {
      return uiTokens.colors.bgElevated;
    }
    if (tone === 'subtle') {
      return 'rgba(10, 10, 12, 0.5)';
    }
    return uiTokens.colors.bgGlass;
  }};
  border: 1px solid ${uiTokens.colors.borderSoft};
  border-radius: ${({ radius = 'md' }) => uiTokens.radius[radius]};
  padding: ${({ padding = 'md' }) => paddingMap[padding]};
  box-shadow: ${({ shadow = true }) => (shadow ? uiTokens.shadow.md : 'none')};
  ${({ blur = true }) =>
    blur &&
    css`
      backdrop-filter: blur(10px);
    `}
`;

export default Card;
